import { useDispatch, useSelector } from 'react-redux'
import { RightButton } from 'components/order/order-list/RightButton'
import { setConfirmationMessage, setModal, setSelectedValue } from 'reducers/listReducer'

export const RightButtonContainer = () => {
    const dispatch = useDispatch()
    const { options, selectedValue } = useSelector((state) => state.listReducer)

    const onShowModal = () => dispatch(setModal({ confirm: true }))

    const onChangeState = (value) => {
        dispatch(setConfirmationMessage(`Are You Sure to Change Order State to ${value.value?.label}?`))
        dispatch(setSelectedValue({ select: value?.value }))
    }

    const props = {
        options,
        selectedValue,
        onShowModal,
        onChangeState,
    }

    return !(selectedValue.tab === 'dibatalkan') && <RightButton {...props} />
}
